import { debounce } from "@mui/material";
import { isNumber } from "@mui/x-data-grid/internals";
import { NumberFormatValues, NumericFormat, NumericFormatProps } from "react-number-format";
import { convertToFloatWithDefaultPrecision } from "src/const/Units";

interface CustomProps {
  onChange: (event: { target: { name: string; value: number } }) => void;
  name: string;
  value: number;
  min: number;
}

const InputNumber = React.forwardRef<NumericFormatProps, CustomProps>(
  function NumericFormatCustom(props, ref) {
    const { onChange, min, ...other } = props;
    
    const onValueChangeHandler = debounce((values: NumberFormatValues) => {
      onChange({
        target: {
          name: props.name,
          value: parseInt(values.value),
        },
      });
    }, 200)    

    return (
      <NumericFormat
        {...other}
        getInputRef={ref}
        onValueChange={onValueChangeHandler}
        allowNegative={min == 0 ? false : true}
        allowedDecimalSeparators={[]}
      />
    );
  },
);

export default InputNumber
